import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle, IconButton, Snackbar } from '@mui/material';
import React, { useEffect } from 'react';

//Severity options are:
//error, warning, info, success

const toTitleCase = str => {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

/**
 * Component for entering in a mobile number.
 *
 * @component SimpleSnackbar
 * @param {object} props props
 * @param {bool} props.open true when the popup should be available
 * @param {string} props.message message for the alert
 * @param {string} props.severity options: error, warning, info, success
 * @return (
 * <SimpleSnackbar/>
 * )
 * @example
 * open="true"
 * message="some problem occured"
 * severity="error"
 */

const timeoutDuration = 3000;

const SimpleSnackbar = props => {
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if (props.open === true) {
            setOpen(true);
        }
    }, [props]);

    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const action = (
        <React.Fragment>
            {/* This section allows for an undo button if the user wants to undo an action
            <Button color="secondary" size="small" onClick={handleClose}>
                UNDO
            </Button> */}
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <div>
            <Snackbar
                open={open}
                autoHideDuration={timeoutDuration}
                onClose={handleClose}
                action={action}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleClose}
                    severity={props.severity}
                    sx={{ width: '100%' }}
                >
                    <AlertTitle>
                        {typeof props.severity !== 'undefined' &&
                            toTitleCase(props.severity)}
                    </AlertTitle>
                    {props.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default SimpleSnackbar;
